/**
 * @name PageJudge.js
 */

class PageJudge {
    main = document.querySelector('main');

    /**
     * ページ判定
     */
    __judge(className) {
        if (this.main.classList.contains(className)) {
            return true;
        }
    }

}

export default PageJudge;